import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { useState } from "react";
import useExportDocxFile from "../../request-vehicle/TemplateDocx/useExportDocxFile";
import { TableHelpers } from "../../../../../helper/TableHelper";
import { requestStatus } from "../../../../../constants";

export const useExternalVehicleTravelCardColumn = () => {
  const [currentItem, setCurrentItem] = useState<any>();
  const { exportForm } = useExportDocxFile({ item: currentItem, docType: 6 });

  const handleSubmit = (item: any) => {
    exportForm(item);
  };

  const renderStage = (stage: string) => {
    return stage === "longTerm" ? "Dài hạn" : "Ngắn hạn";
  };

  const renderSuggestion = (stage: string, suggestion: string) => {
    if (stage === "shortTerm") return suggestion === "provide" ? "Cấp thẻ" : "Cấp lại thẻ";
    return suggestion === "provide" ? "Cấp mới" : suggestion === "evict" ? "Gia hạn" : "Cấp lại";
  };

  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "200px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Giai đoạn giấy phép",
      dataIndex: "eStage",
      key: "eStage",
      render: (text: string) => (
        <span className={text === "longTerm" ? "flag success" : "flag danger"}>{renderStage(text)}</span>
      ),
      width: "180px",
      filters: [
        { text: "Dài hạn", value: "longTerm" },
        { text: "Ngắn hạn", value: "shortTerm" },
      ],
      onFilter: (status: any, record) => record.eStage.indexOf(status) === 0,
    },
    {
      title: "Yêu cầu",
      dataIndex: "eSuggestion",
      key: "eSuggestion",
      render: (text: string, record: any) => (
        <span
          className={
            record.eSuggestion === "provide"
              ? "flag success"
              : record.eSuggestion === "evict"
              ? "flag warning"
              : "flag danger "
          }
        >
          {renderSuggestion(record.eStage, record.eSuggestion)}
        </span>
      ),
      filters: [
        { text: "Cấp thẻ", value: "provide" },
        { text: "Cấp lại thẻ", value: "renew" },
      ],
      onFilter: (status: any, record) => record.eSuggestion.indexOf(status) === 0,
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "200px",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title={"Xuất file"}
          className=""
          variant="outline-info"
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentItem(record);
            handleSubmit(record);
          }}
        >
          <FontFa name="faFileWord" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
